import * as Sentry from "@sentry/nextjs"

import { PriceDetailsFormAttributes } from "@modules/tenants/OrdersPage/OrderSummaryPage/EditPriceModal/PriceDetailsForm"
import { useUpdatePriceOfOrderItemMutation } from "@mono/essentials/entities/order/hooks"
import {
  GetOrderDetailsResponseType,
  UpdatePriceOfOrderItemRequestType,
} from "@mono/essentials/types/OrderTypes"

export const useHandleUpdatePriceOfOrderItem = () => {
  const { mutateAsync: updatePriceOfOrderItemMutation } = useUpdatePriceOfOrderItemMutation()

  const handleUpdatePriceOfOrderItem = async ({
    productsInfo,
    orderItemId,
    onSuccess,
    onError,
    orderData,
  }: {
    productsInfo: PriceDetailsFormAttributes
    orderItemId: string
    onSuccess?: () => Promise<void>
    onError?: (error: any) => Promise<void>
    orderData: GetOrderDetailsResponseType
  }) => {
    try {
      if (productsInfo && orderData?.id && orderItemId) {
        const selectedOrderItem = orderData.items?.find((oi) => oi.id === orderItemId)
        const updatePricePayloads: (UpdatePriceOfOrderItemRequestType & { orderItemId: string })[] =
          []
        productsInfo.productsInfo?.forEach((productInfo) => {
          if (productInfo.cartItemId === orderItemId) {
            const payload: UpdatePriceOfOrderItemRequestType["quantities"] = []
            productInfo?.units?.forEach((unitInfo) => {
              payload.push({
                amount: unitInfo.price,
                unit_id: unitInfo.id,
                booking_id: selectedOrderItem?.booking?.id,
              })
            })
            if (payload?.length)
              updatePricePayloads.push({
                quantities: payload,
                orderItemId: productInfo?.cartItemId,
              })
          } else {
            productInfo?.units?.forEach((unitInfo) => {
              if (unitInfo.orderItemId)
                updatePricePayloads.push({
                  orderItemId: unitInfo.orderItemId,
                  quantities: [
                    {
                      amount: unitInfo.price,
                      unit_id: unitInfo.id,
                      booking_id: selectedOrderItem?.booking?.id,
                    },
                  ],
                })
            })
          }
        })
        // TODO: Need BE support to update multiple item at once
        // await Promise.all(
        //   updatePricePayloads.map(updatePricePayload =>
        //     OrderServices.updatePriceOfOrderItem(orderData?.id, updatePricePayload.orderItemId, updatePricePayload)
        //   )
        // )
        // eslint-disable-next-line no-restricted-syntax
        for (const updatePricePayload of updatePricePayloads) {
          // eslint-disable-next-line no-await-in-loop
          await updatePriceOfOrderItemMutation({
            orderId: orderData?.id,
            orderItemId: updatePricePayload.orderItemId,
            payload: updatePricePayload,
          })
        }
        await onSuccess?.()
      }
    } catch (error) {
      Sentry.captureException(error)
      await onError?.(error)
    }
  }

  return { handleUpdatePriceOfOrderItem }
}
